export default __webpack_public_path__ + "static/media/style4.c86962c2.jpeg";